// extracted by mini-css-extract-plugin
export default {"tab":"SeerchBarTabs_tab__jAZcI","active":"SeerchBarTabs_active__ZLa+-","label":"SeerchBarTabs_label__JA7wA"};